<template>
  <div class="c-album-id">{{ data?.albumCode }}-{{ data?.trackNumber }}</div>
</template>
<script>
import { defineComponent, computed } from 'vue';

export default defineComponent({
  name: 'AlbumId',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const timeLength = computed(() => {
      if (props.data?.track?.duration) {
        const { duration } = props.data?.track;
        const min = Math.floor(duration / 60);
        const sec = duration % 60;

        return `${min < 10 ? `0${min}` : min}:${sec < 10 ? `0${sec}` : sec}`;
      }

      return '';
    });

    return {
      timeLength,
    };
  },
});
</script>
<style lang="scss" scoped>
.c-album-id {
  @include font-style($c-assist4, 14, 400, 0.8px, 26px);
}

@media screen and (min-width: $sm-pc) {
  .c-album-id {
    color: $c-black;
  }
}
</style>
